import BreadCrumbs from "gatsby-theme-dettol/src/components/common/BreadCrumbs/BreadCrumbs"

import "./BreadCrumbsOverride.scss"

export default BreadCrumbs